// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"GjBgO","top":"lLeK+","inner":"_2QiiI","right":"Zh5NT","bottom":"aZ2pb","left":"OAHEq","label":"_1xjMD"};